// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entry-emotion[data-v-655be123]{position:relative;font-size:22px}.entry-emotion__icon[data-v-655be123]{text-align:center}.entry-emotion__delete-icon[data-v-655be123]{position:absolute;right:-15px;top:-5px;font-size:25px}\n", ""]);
// Exports
module.exports = exports;
